import { Navigate, useParams } from 'react-router-dom'

import { useNavigation } from 'modules/core/hooks/useNavigation'

const RedirectToWorkingConditionsVersionDetails = () => {
  const { navigation } = useNavigation()
  const { identifier } = useParams()

  const to = navigation.settings.contracts_settings.workingConditions.version.conditions.fullPath({
    identifier: Number(identifier),
  })

  return <Navigate to={to} />
}

export default RedirectToWorkingConditionsVersionDetails
